import { useCallback, useEffect, useState } from "react";
import { useLazyGetBlsExportQuery } from "../../../services/bl-export/BLExportService";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  setContainerToUpdate,
  setContainers,
  setPageTableBlExport,
  setSizeTableBlExport,
} from "../slices/BlExportSlice";
import { Bl } from "../../../interfaces/bl-export/blexport.interface";

const schema = yup.object().shape({
  type: yup.string().required("Tipo de filtro es requerido"),
  value: yup.string().required("Valor de filtro es requerido"),
  filter_days: yup.string(),
});

const useBlExportBlTable = ({ isHome }: { isHome?: boolean }) => {
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector((state) => state.auth);
  const { page, size } = useAppSelector((state) => state.blExport);
  const [typeFilter, setTypeFilter] = useState<string>();
  const [valueFilter, setValueFilter] = useState<string>();
  const [createdTimeFilter, setCreatedTimeFilter] = useState<number>();
  const [creadoApi, setCreadoApi] = useState(false);
  const [showModalNewBL, setShowModalNewBL] = useState(false);
  const [blToEdit, setBlToEdit] = useState<Bl | undefined>(undefined);
  const [blToClone, setBlToClone] = useState<Bl | undefined>(undefined);
  const [iDToDisable, setIDToDisable] = useState<number>();
  const [iDToDelete, setIDToDelete] = useState<number>();
  const [idBlHistory, setIdBlHistory] = useState<number | undefined>();

  const [getBls, { data, isLoading, isFetching, isError }] =
    useLazyGetBlsExportQuery();

  const openModalNewBL = () => {
    setShowModalNewBL(true);
  };

  const closeModalNewBL = () => {
    setShowModalNewBL(false);
    clearContainersState();
  };

  const openModalCloneBl = (bl: Bl) => {
    setBlToClone(bl);
  };

  const closeModalCloneBl = () => {
    setBlToClone(undefined);
    clearContainersState();
  };

  const openModalEditBl = (bl: Bl) => {
    setBlToEdit(bl);
  };

  const closeModalEditBl = () => {
    setBlToEdit(undefined);
    clearContainersState();
  };

  const openModalBlHistory = (id: number) => {
    setIdBlHistory(id);
  };

  const closeModalBllHistory = () => {
    setIdBlHistory(undefined);
  };

  const openDeleteModal = (iDToDelete: number) => {
    setIDToDelete(iDToDelete);
  };

  const closeDeleteModal = () => {
    setIDToDelete(undefined);
  };

  const openDisableModal = (idToDisable: number) => {
    setIDToDisable(idToDisable);
  };

  const closeDisbaleModal = () => {
    setIDToDisable(undefined);
  };

  const { getFieldProps, errors, touched, handleSubmit, resetForm, values } =
    useFormik({
      initialValues: {
        type: "",
        value: "",
        filter_days: "",
      },
      validationSchema: schema,
      onSubmit: async () => {
        setTypeFilter(values.type);
        setValueFilter(values.value);
        resetPageSizeTable();
      },
    });

  const handleChangePage = (page: number) => {
    dispatch(setPageTableBlExport(page));
  };

  const handleChangeRowsPerPage = (page: number) => {
    dispatch(setSizeTableBlExport(page));
  };

  const resetPageSizeTable = () => {
    dispatch(setPageTableBlExport(0));
    dispatch(setSizeTableBlExport(10));
  };

  const fetchBls = useCallback(() => {
    getBls({
      id_usuario: userInfo?.perfil === "1" ? undefined : Number(userInfo?.id),
      page: isHome ? 0 : page,
      size: isHome ? 10 : size,
      filtro: typeFilter,
      valor: valueFilter,
      creadosHace: createdTimeFilter ? String(createdTimeFilter) : "",
      creados_api: creadoApi ? creadoApi : undefined,
    });
  }, [
    page,
    size,
    typeFilter,
    valueFilter,
    createdTimeFilter,
    creadoApi,
    getBls,
    isHome,
    userInfo?.id,
    userInfo?.perfil,
  ]);

  const handleClearFilters = async () => {
    setCreatedTimeFilter(undefined);
    setTypeFilter("");
    setValueFilter("");
    resetForm();
    resetPageSizeTable();
  };

  const clearContainersState = () => {
    dispatch(setContainerToUpdate(undefined));
    dispatch(setContainers([]));
  };

  useEffect(() => {
    fetchBls();
    return;
  }, [fetchBls]);

  useEffect(() => {
    fetchBls();
  }, [page, size, creadoApi, fetchBls]);

  return {
    userInfo,
    createdTimeFilter,
    setCreatedTimeFilter,
    creadoApi,
    setCreadoApi,
    showModalNewBL,
    openModalNewBL,
    closeModalNewBL,
    blToClone,
    openModalCloneBl,
    closeModalCloneBl,
    blToEdit,
    openModalEditBl,
    closeModalEditBl,
    iDToDisable,
    openDisableModal,
    closeDisbaleModal,
    iDToDelete,
    openDeleteModal,
    closeDeleteModal,
    idBlHistory,
    openModalBlHistory,
    closeModalBllHistory,
    fetchBls,
    getFieldProps,
    errors,
    touched,
    handleSubmit,
    handleClearFilters,
    values,
    page,
    size,
    handleChangePage,
    handleChangeRowsPerPage,
    data,
    isLoading,
    isFetching,
    isError,
  };
};

export default useBlExportBlTable;
